module.exports = __webpack_public_path__ + "static/img/settings.90ec343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/settings.png
// module id = 48
// module chunks = 1 2